export default {
  traceability: {
    traceability: "Traceerbaarheid",
    coffeeTraceabilityMngmnt: "Beheer van koffietraceerbaarheid",
    traceabilityPage: "Traceerbaarheidspagina",
    labelDesigner: "Labelontwerper",
    additionalInformation: "Aanvullende informatie",
    info1:
      "Biedt informatie over aanvullende logo's van uw product. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
    addSlogan: "Slogan toevoegen",
    additionalLogos: "Aanvullende logo's",
    title: "Titel",
    description: "Omschrijving",
    mapLink: "Kaartlink",
    websiteLink: "Websitelink",
    addMedia: "Media toevoegen",
    uploadImageVideo: "Afbeelding/video uploaden",
    uploadImage: "Afbeelding uploaden",
    traceabilityImage: "traceerbaarheid afbeelding",
    enableLogoProcessing: "Logo verwerking inschakelen",
    origin: "Oorsprong",
    info2:
      "Biedt informatie over het land van herkomst van uw product. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
    countryImage: "Afbeelding van het land",
    institutionalInfo: "Institutionele informatie",
    info3:
      "Biedt informatie over uw bedrijf/coöperatie, vertel consumenten over het relevante werk dat u heeft gedaan. Deze informatie is beschikbaar voor het publiek op de koffietraceerbaarheidspagina.",
    cooperativeLogo: "Coöperatief logo",
    traceabilityIntro: "Inleiding tot traceerbaarheid",
    info4:
      "Deze sectie geeft de consument toegang tot de volledige productie- en verwerkingsgeschiedenis van de koffie. Beschrijf de relevantie van traceerbaarheid voor uw bedrijf/coöperatie en voor de wereld.",
    addLabel: "Label toevoegen",
    chooseTitle: "Titel kiezen",
    chooseLabelDesign: "Kies labelontwerpsjabloon",
    uploadYourLogo: "Upload uw logo",
    info5:
      "Instructies: De afbeeldingsgrootte moet minimaal 1000 x 1000 pixels zijn. U kunt een transparante PNG kiezen om overeen te komen met de achtergrondkleuren.",
    chooseTemplateColors: "Kies sjabloonkleuren",
    backgroundColor: "Achtergrondkleur",
    foregroundColor: "Hoofdkleur",
    labelStatus: "Labelstatus",
    inactive: "Inactief",
    download: "Downloaden",
    enterLabelTitle: "Voer de titel van het label in",
  },
  cacaoTraceability: {
    traceability: "Traceerbaarheid",
    cacaoTraceabilityMngmnt: "Beheer van cacaotraceerbaarheid",
    traceabilityPage: "Traceerbaarheidspagina",
    labelDesigner: "Labelontwerper",
    additionalInformation: "Aanvullende informatie",
    info1:
      "Biedt informatie over aanvullende logo's van uw product. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
    addSlogan: "Slogan toevoegen",
    corporativeTile: "Coöperatieve tegel",
    additionalLogos: "Aanvullende logo's",
    title: "Titel",
    description: "Omschrijving",
    mapLink: "Kaartlink",
    websiteLink: "Websitelink",
    addMedia: "Media toevoegen",
    uploadImageVideo: "Afbeelding/video uploaden",
    origin: "Oorsprong",
    info2:
      "Biedt informatie over het land van herkomst van uw product. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
    countryImage: "Afbeelding van het land",
    institutionalInfo: "Institutionele informatie",
    info3:
      "Biedt informatie over uw bedrijf/coöperatie, vertel consumenten over het relevante werk dat u heeft gedaan. Deze informatie is beschikbaar voor het publiek op de cacaotraceerbaarheidspagina.",
    cooperativeLogo: "Coöperatief logo",
    traceabilityIntro: "Inleiding tot traceerbaarheid",
    info4:
      "Deze sectie geeft de consument toegang tot de volledige productie- en verwerkingsgeschiedenis van de cacao. Beschrijf de relevantie van traceerbaarheid voor uw bedrijf/coöperatie en voor de wereld.",
    addLabel: "Label toevoegen",
    chooseTitle: "Titel kiezen",
    chooseLabelDesign: "Kies labelontwerpsjabloon",
    uploadYourLogo: "Upload uw logo",
    info5:
      "Instructies: De afbeeldingsgrootte moet minimaal 1000 x 1000 pixels zijn. U kunt een transparante PNG kiezen om overeen te komen met de achtergrondkleuren.",
    chooseTemplateColors: "Kies sjabloonkleuren",
    backgroundColor: "Achtergrondkleur",
    foregroundColor: "Hoofdkleur",
    labelStatus: "Labelstatus",
    inactive: "Inactief",
    download: "Downloaden",
    enterLabelTitle: "Voer de titel van het label in",
  },
};
